import React from 'react'
import moment from 'moment'
import { Text } from '@Common/Components'

const SIZE_TEXT = 15
function TcDisplay ({ data }) {
  const renderDate = (date) => (
    <div style={{ display: 'flex', flexDirection: 'row', marginRight: 20 }}>
      <Text size={50} value={moment(date).format('DD')} />
      <div style={{ marginTop: 14, marginLeft: 5 }}>
        <Text size={17} value={moment(date).format('MMMM')} />
        <Text size={17} value={moment(date).format('YYYY')} />
      </div>
    </div>
  )
  const renderDescription = () => (
    <div
      style={{
        ...Styles.divContainer,
        minWidth: 150
      }}
    >
      <Text size={15} value='Descrizione:' style={{ marginRight: 20 }} />
      <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Text size={15} bold value={data.description} style={{ marginRight: 20, width: '100%' }} />
      </div>
    </div>
  )
  const renderStartDate = () => (
    <div
      style={{
        ...Styles.divContainer
      }}
    >
      <Text size={SIZE_TEXT} value='Inizio viaggio:' style={{ marginRight: 20 }} />

      <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {renderDate(data.startDate)}
      </div>
    </div>
  )
  const renderEndDate = () => (
    <div
      style={{
        ...Styles.divContainer
      }}
    >
      <Text size={SIZE_TEXT} value='Fine viaggio:' style={{ marginRight: 20 }} />
      <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {renderDate(data.endDate)}
      </div>
    </div>
  )

  const renderDivision = () => (
    <div
      style={{
        width: 2,
        height: '100%',
        backgroundColor: 'white',
        border: '1px solid #32324e',
        maxHeight: 97
      }}
    />
  )

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center' }}>
      {renderDescription()}
      {renderDivision()}
      {renderStartDate()}
      {renderDivision()}
      {renderEndDate()}
    </div>
  )
}
const Styles = {
  divContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: 20
  }
}

export default TcDisplay
